import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

import { CloseIcon } from "./icons";

export interface BottomMobileOptionsModalProps
  extends React.ComponentProps<typeof Dialog> {
  bodyClassName?: string;
  headerClassName?: string;
  isCloseable?: boolean;
  title?: string;
}

export default function BottomMobileOptionsModal({
  bodyClassName,
  children,
  headerClassName,
  isCloseable = true,
  title,
  ...props
}: BottomMobileOptionsModalProps) {
  return (
    <Dialog {...props}>
      <DialogContent
        className="gap-0 rounded-t-[15px] rounded-b-none bg-[url(/images/main-bg.jpg)] bg-cover bg-top md:rounded-[15px] md:bg-twilight-indigo"
        overlayClassName="bg-gray-cool/64 md:bg-black/40"
      >
        {!!title && (
          <DialogHeader
            className={cn(
              "relative border-navy-gray border-b",
              headerClassName
            )}
          >
            {isCloseable && (
              <Button
                aria-label="Close"
                className="absolute top-5 left-6 flex size-[25px] items-center justify-center rounded-full border border-white"
                onClick={() => props.onOpenChange?.(false)}
              >
                <CloseIcon />
              </Button>
            )}
            <DialogTitle className="text-center font-semibold text-16/16 text-white">
              {title}
            </DialogTitle>
          </DialogHeader>
        )}
        <div className={cn("px-3.5 py-2.5", bodyClassName)}>{children}</div>
      </DialogContent>
    </Dialog>
  );
}
